import PropTypes from 'prop-types';
import React from 'react';
import i18next from "../../i18n";
import { getDictionary } from '../Dictionary';
import { Table, TableColumnType } from '../table/Table';
export class ExternalSigners extends React.Component {
    static propTypes = {
        signers: PropTypes.array
    };
    constructor(props) {
        super(props);
        this.state = {
            statuses: []
        }
    }
    componentDidMount() {
        getDictionary('cm:Signing/cm:Signing_x0020_states')
            .then(data => {
                if (data) {
                    this.setState({
                        statuses: data
                    });
                }
            });
    }
    render() {
        const { signers } = this.props;
        const { statuses } = this.state;
        let table = {
            "columns": [
                {
                    "id": "0",
                    "name": "Id",
                    "headerName": "",
                    "type": TableColumnType.String,
                    "hidden": true
                },
                {
                    "id": "1",
                    "name": "creatorFullName",
                    "headerName": i18next.t("fullName"),
                    "type": TableColumnType.String
                },
                {
                    "id": "2",
                    "name": "creatorPosition",
                    "headerName": i18next.t("positionHeld"),
                    "type": TableColumnType.String
                },
                {
                    "id": "3",
                    "name": "signingState",
                    "headerName": i18next.t("status"),
                    "type": TableColumnType.Status
                },
                {
                    "id": "4",
                    "name": "signingDate",
                    "headerName": i18next.t("dateSigning"),
                    "type": TableColumnType.String
                },
                {
                    "id": "5",
                    "name": "signingCommentsPreview",
                    "headerName": i18next.t("remark"),
                    "type": TableColumnType.Comment
                }
            ]
        }
        let rows = [];
        if (signers) {
            for (let i = 0; i < signers.length; ++i) {
                let signingDate = signers[i].properties?.signingDate ? new Date(signers[i].properties.signingDate) : "";
                rows.push({
                    actions: [],
                    columns: {
                        Id: signers[i].properties?.id,
                        creatorFullName: signers[i].performerInfo?.fullName,
                        creatorPosition: signers[i].performerInfo?.position,
                        signingState: statuses?.find(obj => obj?.value === signers[i]?.properties?.signingState)?.label,
                        signingDate: signingDate ? `${signingDate.toLocaleDateString("uk-UA")} ${signingDate.toLocaleTimeString("uk-UA").substring(0, 5)}` : signingDate,
                        signingCommentsPreview: signers[i].properties?.signingCommentsPreview,
                    }
                });
            }
        }
        return (
            <div className="large-form doc-form">
                <Table name={"external-signers"} columns={table.columns} items={rows} />
            </div>
        );
    }
}